"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateEncryptionKeyBox = exports.bytesToObj = exports.objToBytes = void 0;
const key_1 = require("./key");
// convert a js object to and from a byte stream by stringifying and encoding it as an utf8 byte array
const objToBytes = (obj) => new TextEncoder().encode(JSON.stringify(obj));
exports.objToBytes = objToBytes;
const bytesToObj = (bytes) => JSON.parse(new TextDecoder().decode(bytes));
exports.bytesToObj = bytesToObj;
const hydrateEncryptionKeyBox = async (keyBox, signingString, signer) => {
    await (0, key_1.generateX25519KeyPairFromSignature)(signer, signingString, keyBox);
};
exports.hydrateEncryptionKeyBox = hydrateEncryptionKeyBox;
